<form *ngIf="groupUserFormGroup" [formGroup]="groupUserFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="userId">Usuario *</label>
            <p-dropdown [options]="users" formControlName="userId" optionValue="id" [filter]="true" filterBy="name"
                optionLabel="name" placeholder="Seleccione usuario" appendTo="body" d-form-field-error />
        </div>
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>